import 'magnific-popup'
import $ from 'jquery'

const gamesModal = () => {
    $('.popup-games').magnificPopup({
        type: 'inline',
    });
    $('.js-popup-close').on('click', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
}

window.addEventListener('load', () => {
    gamesModal()
})